import { Box, Button, Typography } from "@mui/joy";
import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { consultantRemove, consultantUpdate } from "../../service/consultantService";
import { RouteComponentProps } from "../../models/RouteComponent";
import { UserTypes } from "../../enum/UserTypes";
import { useNavigate } from "react-router-dom";
import { accessLevelRemove } from "../../service/accessLevelService";
import { TabPanel, TabView } from "primereact/tabview";
import { Card } from "primereact/card";
import { FormControl, FormLabel, Grid } from "@mui/material";

export default function AccessLevelsTable(props: RouteComponentProps) {

  const navigate = useNavigate();

  const [selectedConsultant, setSelectedConsultant] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const toast = useRef(null as any);
  const [reload, setReload] = useState(false);
  const dialog = useRef(null as any);

  const adminBaseFilter = {
    'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
    'active': { value: true, matchMode: FilterMatchMode.CONTAINS },
    'is_admin': { value: true, matchMode: FilterMatchMode.CONTAINS },
  }

  const userBaseFilter = {
    'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
    'active': { value: true, matchMode: FilterMatchMode.CONTAINS },
    'is_admin': { value: false, matchMode: FilterMatchMode.CONTAINS },
  }

  const addButton = (row: any, isAdmin?: boolean) => {
    console.log("row == ", row);
    setSelectedConsultant(null);
    if (props.setAccessLevel) {
      props.setAccessLevel({
        is_admin: isAdmin
      });
    }
    navigate('/access-level-view');
  }

  const itemSelected = (row: any) => {
    const value = row.value;
    setSelectedConsultant(value);
    if (props.setAccessLevel) {
      props.setAccessLevel(value);
    }
    viewSelected(row);
    // navigate('/access-level-view');
  }

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setSelectedConsultant(row.value);
    if (props.setAccessLevel) {
      props.setAccessLevel(row.value);
    }
  }

  const DialogSetVisible = (row: any) => {
    setVisible(true);
  }

  const viewSelected = (row: any) => {
    navigate('/access-level-view');
  }

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await accessLevelRemove(selectedConsultant.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'Access Level Deleted Successfully', life: 3000 });
  }


  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc()
    });
  }


  const changeStatusFunc = async (status: boolean) => {
    props.setGlobalLoader(true);
    const client = await consultantUpdate({ "active": status }, selectedConsultant.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: status ? 'Access Level Activated Successfully' : 'Access Level Deactivated Successfully', life: 3000 });
  }

  const disableConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to deactivate access level?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(false)
    });
  }

  const activateConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to activate access level?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(true)
    });
  }

  const contextItems = () => {
    let objArray = [
      { label: 'View', icon: 'pi pi-fw pi-eye', command: viewSelected },
    ];
    if (selectedConsultant?.active) {
      objArray.push({ label: 'Deactivate', icon: 'pi pi-fw pi-times-circle', command: disableConfirm })
    } else {
      objArray.push({ label: 'Activate', icon: 'pi pi-fw pi-check-circle', command: activateConfirm })
    }
    objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    return objArray;
  }



  const columns: GenericTableColumns[] = [
    {
      field: 'name',
      header: 'Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'active',
      header: 'Active',
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'created_at',
      header: 'Created At',
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: true,
      filter: false
    }
  ];


  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
          App Access Levels
        </Typography>


        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>
      <GenericTableView reload={reload} baseFilters={userBaseFilter} url="access-level" columns={columns} contextItems={contextItems} addButton={addButton} itemSelect={itemSelected} contextItemSelected={contextItemSelected} />

      <ConfirmDialog />
      <Toast ref={toast} />
    </React.Fragment>
  );
}